import { ChangeLossControlCardsLoading, ChangeLossControlDays, ChangeLossControlDaysLoading, changeLossControlDonutData, 
    changeLossControlDonutDataTotal, ChangeLossControlCards, LogOut, ChangeLossControlStatus } from "../../Redux/Actions/index.js"
import { store } from "../../Redux/Store/index.js"
import { toast } from "react-toastify";
import config from "../../Config/config.json";
import { ControlePerdasRequest } from "./requests.ts"

export class ControlePerdasService {
    constructor(){
        this.ControlePerdasRequest = new ControlePerdasRequest();
        this.cards = []
        this.initialCard =
            [
                {
                    "Active": false,
                    "type": 0,
                    "focus": true,
                }
            ]
    }


    async generateCards(newCards){
        if(JSON.parse(localStorage.getItem('AugenCard'))){
            this.generateOrderCards(JSON.parse(localStorage.getItem('AugenCard')));
        }else{
            let Tempcards = []
            newCards.map((card) => {
                card.Active = true
                Tempcards.push(card);
                return card;
            });
            while (Tempcards.length < 5) {
                Tempcards.push({
                    Active: false,
                    type: 0,
                });
            }    
            Tempcards[0].focus = true;
            if(Tempcards[0].id){
                this.getDayData(Tempcards[0].id, Tempcards[0].key, Tempcards[0].name, Tempcards[0].idEquipment);
                store.dispatch(ChangeLossControlStatus(Tempcards[0].status));
            }
            this.cards = Tempcards;
            try {
                localStorage.setItem('AugenCard', JSON.stringify(Tempcards));
            } catch (error) {
                
            }
            if(this.search){
                Tempcards = this.FilterCards(this.search);
            }
            store.dispatch(ChangeLossControlCards(JSON.parse(JSON.stringify(Tempcards)), Tempcards[0].name));
        }
    }


    // Altera o card que está em foco
    async changeFocus(cardid, indice, key, idEquipment){
        console.log('indice', indice)
        try {
            let newIndex = 0;
            let focusCard;
            let oldCard;
            let status = 0;
            this.cards.map((card, index) => {
                if(card.id === cardid && card.key === key && card.idEquipment === idEquipment){
                    focusCard = card;
                    card.focus = true;
                    status = card.status;
                }else if(card.focus === true){
                    newIndex = index;
                    oldCard = card;
                    card.focus = false;
                }
                return card;
            })
            this.cards[newIndex] = focusCard;
            this.cards[indice] = oldCard;
            let name = focusCard.name;
            this.getDayData(name, key);
            store.dispatch(ChangeLossControlStatus(status));

            if(this.search){
                let Tempcards = this.FilterCards(this.search);
                store.dispatch(ChangeLossControlCards(JSON.parse(JSON.stringify(Tempcards)), name));
            }else{
                store.dispatch(ChangeLossControlCards(JSON.parse(JSON.stringify(this.cards)), name));
            }
            
            localStorage.setItem('AugenCard', JSON.stringify(this.cards));
        } catch (error) {
            console.log(error)
        }
    }


    // Pega os dados dos dias
    async getDayData(card, key){
        if(card){
            try {
                store.dispatch(ChangeLossControlDaysLoading(true));
                let data = store.getState().DashboardControlePerdasReducer.year + '-' + store.getState().DashboardControlePerdasReducer.month + '-' + store.getState().DashboardControlePerdasReducer.day;
                let flag = store.getState().DashboardControlePerdasReducer.Mode;
                let chartData =  await this.ControlePerdasRequest.Chart(key, data, flag);
                this.formatDayData(chartData, card);
                store.dispatch(ChangeLossControlDaysLoading(false));
            } catch (error) {
                console.log(error)
                toast(error.message, {
                    position: "top-center",
                    type: 'error',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: config.theme,
                });
                if(error.status === 401){
                    store.dispatch(LogOut());
                }
                this.formatDayData({}, card);
                store.dispatch(ChangeLossControlDaysLoading(false));
                return;
            }
        }
    }

    // Altera o dia
    async changeDay(day, month, year){
        // const data = year + '-' + month + '-' + day;
        this.getDayData()
    }
    
    // Método para alterar o mes/ano
    async changeMonthYear(day, month, year){
        const data = year + '/' + month;
        this.loadDashboard(data);
    }


    // Refaz o request para as hora (funciona para dias tbm)
    async getHoursData(){
        let focusCard;
        this.cards.map(card => {
            if(card.focus){
                focusCard = card
            }
            return card;
        })
        // if(focusCard.key){
            try {
                store.dispatch(ChangeLossControlDaysLoading(true));
                let data = store.getState().DashboardControlePerdasReducer.year + '-' + store.getState().DashboardControlePerdasReducer.month + '-' + store.getState().DashboardControlePerdasReducer.day;
                let flag = store.getState().DashboardControlePerdasReducer.Mode;
                let newData = await this.ControlePerdasRequest.Chart(focusCard.key, data, flag);
                this.formatDayData(newData, focusCard.key);
                store.dispatch(ChangeLossControlDaysLoading(false));
            } catch (error) {
                console.log(error)
                toast(error.message, {
                    position: "top-center",
                    type: 'error',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: config.theme,
                });
                if(error.status === 401){
                    store.dispatch(LogOut());
                }
                this.formatDayData({}, focusCard.key);
                store.dispatch(ChangeLossControlDaysLoading(false));
                return;
            }
        // }
    }


    async loadDashboard(data) {
        try {
            store.dispatch(ChangeLossControlCardsLoading(true));

            const { donut, cards } =
                await this.ControlePerdasRequest.getDashboardData(data);

            // 🔹 Cards]
            await this.generateCards(cards, true);

            // 🔹 Donut
            store.dispatch(changeLossControlDonutDataTotal(donut));
            await this.generateDonut(donut);

            store.dispatch(ChangeLossControlCardsLoading(false));

        } catch (error) {
            console.log(error);

            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                theme: config.theme,
            });

            if (error.status === 401) {
                store.dispatch(LogOut());
            }
            this.cards = this.initialCard;
            store.dispatch(ChangeLossControlCards(this.initialCard));
            store.dispatch(ChangeLossControlCardsLoading(false));
        }
    }

    async generateDonut(newDonut){

         try {

            const chartData = newDonut.map(item => ({
                label: item.name,
                value: item.total
            }));

            store.dispatch(changeLossControlDonutData(chartData));
            return chartData;    

        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            this.formatDayData({}, 'SD');
            return;
        }

    }


    // Gera os cards no formato correto
    async generateOrderCards(newCards, changedays){
        let Tempcards = []
        let oldcards = JSON.parse(localStorage.getItem('AugenCard'));
        // console.log('oldcards', oldcards)
        // console.log('json', JSON.parse(localStorage.getItem('AugenCard')))
        let name;
        if (oldcards) {

            newCards.map(card => {
                if(!oldcards.some(oldcard => oldcard.id === card.id && oldcard.key === card.key)){
                    card.Active = true;
                    card.focus = false;
                    oldcards.push(card);
                }
                return card;
            })

            oldcards.map((card) => {
                        let temp = newCards.find(newcard => newcard.id === card.id && newcard.key === card.key)
                        if(temp){
                            temp.Active = true;
                            temp.focus = card.focus;
                            if(card.focus){
                                if(!changedays){
                                    this.getDayData(temp.name, temp.key);
                                }
                                store.dispatch(ChangeLossControlStatus(temp.status));
                                name = temp.name;
                            } 
                            Tempcards.push(temp);
                        }
                        return card;
                    });


        } else {
            newCards.map((card) => {
                card.Active = true
                Tempcards.push(card);
                return card;
            });
            
        }
        // Verifica se o card que está em foco ainda existe
        if(!name && Tempcards?.length > 0){
            Tempcards[0].focus = true;
            name = Tempcards[0].name;
            store.dispatch(ChangeLossControlStatus(Tempcards[0].status));
        }

        this.cards = Tempcards;
        if(this.search){
            Tempcards = this.FilterCards(this.search);
        }
        store.dispatch(ChangeLossControlCards(JSON.parse(JSON.stringify(Tempcards)), name));
        try {
            localStorage.setItem('AugenCard', JSON.stringify(Tempcards));
        } catch (error) {
            
        }
        setTimeout(() => {
            store.dispatch(ChangeLossControlCardsLoading(false));
        }, 5);
        console.log('newcards final', newCards)
        console.log('oldcards final', oldcards)
        console.log('Tempcards final', this.cards)
    }

   
    // Formata os dados para o gráfico dos dias
    formatDayData(dados, name){
        let values = Object.values(dados);
        let datas = Object.keys(dados);
        let temp = values.map((valor, index) => {
            let hoje = new Date();
            return{
                y: valor,
                x: datas[index].length < 3 ? new Date(hoje.setHours(datas[index])) : new Date(datas[index])
            }
        })
        let data ={
            "id": name ? name : store.getState().DashboardControlePerdasReducer.name,
            "data": temp
        }
        let newdata = [];
        data.data.sort((a, b) => a.x - b.x);
        newdata.push(data);
        store.dispatch(ChangeLossControlDays(newdata));
    }


    FilterCards(search) {
        this.search = search;

        // Cria um novo array filtrando os cards
        const newCards = this.cards.filter(card => 
            card.name.toLowerCase().includes(search.toLowerCase())
        );

        this.filteredCards = newCards;

        // Pega o card focado de forma segura
        const focusedCard = this.cards.find(card => card.focus === true);
        const name = focusedCard ? focusedCard.name : null;

        // Atualiza o store
        store.dispatch(ChangeLossControlCards(JSON.parse(JSON.stringify(newCards)), name));

        return JSON.parse(JSON.stringify(newCards));
    }

}